// flow weak

import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import {Link} from 'react-router-dom';
import { withRouter } from 'react-router';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import Dialog from 'material-ui/Dialog';
import RaisedButton from 'material-ui/RaisedButton';
import AddCompetitionExpenses from '../addCompetitionExpense';
import { colors, btn, btnGroup, card, table, modal, empty } from '../../../../style/common/partnerStyle';

class ViewCompetitionExpense extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      id:props.id,
      competition_id:props.competition_id,
      status_types: [],
      expense_types: [],
      buddy_search_list:[],
      data_uploaded: false,
      data_error: false,
      search:true,
      addExpenseView:false,
      expense_details:[],
      billView:false,
      deleteExpense:false,
      bill_source:'',
      selected_expense_id:'',
      purposes:[],
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleFilebill = this.handleFilebill.bind(this);
    this.getCompetitionExpenseInputs = this.getCompetitionExpenseInputs.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.getSearchList = this.getSearchList.bind(this);
    this.setSearch = this.setSearch.bind(this);
    this.getExpenseDetail = this.getExpenseDetail.bind(this);
  }

  componentDidMount() {
    console.log(this.state);
    console.log('this is componentDidMount')
    this.getExpenseDetail();
    this.getCompetitionExpenseInputs();
  }

  getCompetitionExpenseInputs() {
    const url = `${getLocationOrigin()}/eagleeye/get_inputs_for_competition_expense/`;
    const options = {...defaultOptions};
    return fetch(url, options)
      .then(checkStatus).then(parseJSON)
      .then(data => this.setState({status_types: data.status_types,expense_types: data.expense_types,purposes:data.purposes}))
      .catch(error => { console.log(error); alert(error.message); });
  }

  getExpenseDetail() {
    const url = `${getLocationOrigin()}/tournament/get_competition_expense/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({ 'competition_id': this.state.competition_id });
    return fetch(url, options)
      .then(checkStatus).then(parseJSON)
      .then(data => this.setState({expense_details: data.expense_detail, search: true}))
      .catch(error => { console.log(error); alert(error.message); });
  }

  getSearchList(expense_id) {
    this.setState({selected_expense_id:expense_id})
    var mobile_no = '';
    var new_selected_one = Object.assign([], this.state.expense_details);
    for(var i=0;i<new_selected_one.length;i++){
      if(new_selected_one[i].id == expense_id){ mobile_no = new_selected_one[i].mobile_no }
    }
    const url = `${getLocationOrigin()}/eagleeye/search_buddy/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({ 'search': mobile_no });
    return fetch(url, options)
      .then(checkStatus).then(parseJSON)
      .then(data => this.setState({buddy_search_list: data.results, search: true}))
      .catch(error => { console.log(error); alert(error.message); });
  }

  setSearch(name, buddy_id, mobile_no, expense_id){
    var new_selected_one = Object.assign([], this.state.expense_details);
    for(var i=0;i<new_selected_one.length;i++){
      if(new_selected_one[i].id == expense_id){
        new_selected_one[i]['new_paid_by'] = buddy_id
        new_selected_one[i]['paid_by'] = [buddy_id,name]
      }
    }
    this.setState({expense_details: new_selected_one, search: false});
  }

  postSaveExpense(data, props) {
    console.log(data);
    console.log('postSaveExpense')
    const url = `${getLocationOrigin()}/tournament/save_expense_details/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({
      'id': data.id, 'purpose':data.purpose, 'item':data.item, 'quantity':data.quantity, 'size':data.size,
      'amount':data.amount, 'status':data.status, 'expense_type':data.expense_type,
      'new_paid_on_date':data.new_paid_on_date, 'new_bill':data.new_bill, 'new_paid_by':data.new_paid_by,
    });
    console.log('Going to fetch');
    return fetch(url, options)
      .then(checkStatus).then(parseJSON)
      .then((response) => { alert(response.message); this.setState({addExpenseView:false}) })
      .catch(error => { console.log(error); alert(error.message); });
  }

  postDeleteExpense(){
    console.log('postDeleteExpense')
    const url = `${getLocationOrigin()}/tournament/delete_competition_expense/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({ 'id': this.state.selected_expense_id });
    return fetch(url, options)
      .then(checkStatus).then(parseJSON)
      .then(data => { alert(data.message); this.setState({deleteExpense:false}); this.getExpenseDetail(); })
      .catch(error => { console.log(error); alert(error.message); });
  }

  handleChange(event, expense_id) {
    const name = event.target.name;
    console.log(this.state.expense_details)
    console.log(expense_id)
    var new_selected_one = Object.assign([], this.state.expense_details);
    for(var i=0;i<new_selected_one.length;i++){
      if(new_selected_one[i].id == expense_id){
        console.log('yes this is matching')
        new_selected_one[i][name] = event.target.value
        this.setState({expense_details: new_selected_one});
      }
    }
    console.log(this.state.expense_details)
  }

  handleDateChange(date, expense_id){
    var new_selected_one = Object.assign([], this.state.expense_details);
    for(var i=0;i<new_selected_one.length;i++){
      if(new_selected_one[i].id == expense_id){
        new_selected_one[i]['new_paid_on_date'] = date
        new_selected_one[i]['paid_on_date'] = date
        this.setState({expense_details: new_selected_one});
        console.log(this.state.expense_details)
      }
    }
  }

  handleDeleteExpense(expense_id){
    this.setState({selected_expense_id:expense_id,deleteExpense:!this.state.deleteExpense,billView:false})
  }

  handleSubmit(expense_id) {
    console.log(expense_id)
    var obj = Object.assign([], this.state.expense_details);
    var new_obj = {}
    for (var i=0;i<obj.length;i++){
      if(obj[i].id == expense_id){
        new_obj = obj[i]
        if(!new_obj['new_bill']){new_obj['new_bill'] = ''}
        if(!new_obj['new_paid_by']){new_obj['new_paid_by'] = ''}
        if(new_obj['new_paid_on_date']){ new_obj['new_paid_on_date'] = moment(new_obj['new_paid_on_date']) }
        else{ new_obj['new_paid_on_date'] = '' }
        this.postSaveExpense(new_obj, this.props);
      }
    }
    console.log('post');
    console.log(this.state);
  }

  toAddExpense(){ this.setState({addExpenseView:!this.state.addExpenseView}) }

  onViewBill(bill_source, expense_id){
    this.setState({billView:!this.state.billView,bill_source:bill_source,selected_expense_id:expense_id})
  }

  handleFilebill(selectorFiles){
    var new_selected_one = Object.assign([], this.state.expense_details);
    console.log(selectorFiles);
    for (var i=0;i<new_selected_one.length;i++){
      if(new_selected_one[i].id == this.state.selected_expense_id){
        new_selected_one[i]['new_bill'] = selectorFiles[0]
        this.setState({expense_details: new_selected_one,bill_source:''});
        console.log(this.state.expense_details);
      }
    }
  }

  render() {
    const okaction = <input type="button" className="button1" value="OK" onClick={() => {this.onViewBill()}} /> ;
    const deleteAction = [
        <input type="button" className="button1" value="Delete" style={{backgroundColor:'red',marginRight:'10px'}} onClick={() => {this.postDeleteExpense()}} />,
        <input type="button" className="button1" value="Cancel" onClick={() => {this.handleDeleteExpense()}} />
      ];

    const totalAmount = this.state.expense_details.reduce((sum, e) => sum + (parseFloat(e.amount) || 0), 0);

    return (
      <div style={{ fontFamily: "'DM Sans', 'Segoe UI', sans-serif" }}>

        <div style={card.header}>
          <h2 style={card.title}>
            Expenses
            {this.state.expense_details.length > 0 && <span style={card.titleCount}>{this.state.expense_details.length} entries</span>}
          </h2>
          <Link to={"/crud/addCompetitionExpense/" + this.state.competition_id}>
            <button style={btn.primary}>+ Add Expense</button>
          </Link>
        </div>

        {this.state.expense_details.length > 0 && (
          <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', padding: '20px 24px', borderBottom: `1px solid ${colors.border}` }}>
            <div style={{ flex: '1 1 160px', background: colors.bg, borderRadius: 12, padding: '18px 22px', display: 'flex', flexDirection: 'column', gap: 4 }}>
              <div style={{ fontSize: 11, fontWeight: 600, letterSpacing: '0.06em', textTransform: 'uppercase', color: colors.muted }}>Total Expenses</div>
              <div style={{ fontSize: 28, fontWeight: 700, color: colors.text, lineHeight: 1.2 }}>{this.state.expense_details.length}</div>
            </div>
            <div style={{ flex: '1 1 160px', background: colors.bg, borderRadius: 12, padding: '18px 22px', display: 'flex', flexDirection: 'column', gap: 4 }}>
              <div style={{ fontSize: 11, fontWeight: 600, letterSpacing: '0.06em', textTransform: 'uppercase', color: colors.muted }}>Total Amount</div>
              <div style={{ fontSize: 28, fontWeight: 700, color: colors.success, lineHeight: 1.2 }}>₹{totalAmount.toLocaleString('en-IN')}</div>
            </div>
          </div>
        )}

        {this.state.expense_details.length > 0 ? (
          <div style={table.wrap}>
            <table style={table.table}>
              <thead>
                <tr>
                  {['#', 'Purpose', 'Item', 'Quantity', 'Amount', 'Status', 'Type', 'Actions'].map(col => (
                    <th key={col} style={table.th}>{col}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {this.state.expense_details.map((expense, index) => (
                  <tr key={index} style={index % 2 === 1 ? table.trAlt : {}}>
                    <td style={table.tdMuted}>{index + 1}</td>
                    <td style={table.td}>
                      {this.state.purposes && this.state.purposes.map((purpose, i) => (
                        <span key={i}>{purpose[0] == expense.purpose && purpose[1]}</span>
                      ))}
                    </td>
                    <td style={table.tdBold}>{expense.item}</td>
                    <td style={table.td}>{expense.quantity}</td>
                    <td style={table.tdAmount}>{expense.amount ? `₹${parseFloat(expense.amount).toLocaleString('en-IN')}` : '—'}</td>
                    <td style={table.td}>
                      {this.state.status_types.map((x, i) => <span key={i}>{x[0] == expense.status && x[1]}</span>)}
                    </td>
                    <td style={table.td}>
                      {this.state.expense_types.map((type, i) => <span key={i}>{type[0] == expense.expense_type && type[1]}</span>)}
                    </td>
                    <td style={table.td}>
                      <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                        <a href={`../../#/crud/editCompetitionExpense/${expense.id}`} title="Edit">
                          <button style={btn.outlineSm}>Edit</button>
                        </a>
                        <button style={btn.dangerLt} onClick={() => this.handleDeleteExpense(expense.id)}>Delete</button>
                      </div>
                    </td>
                  </tr>
                ))}
                <tr style={table.trTotal}>
                  <td colSpan={4} style={table.tdTotalLabel}>Total ({this.state.expense_details.length} expenses)</td>
                  <td style={table.tdTotalAmount}>₹{totalAmount.toLocaleString('en-IN')}</td>
                  <td colSpan={3} style={table.tdEmpty} />
                </tr>
              </tbody>
            </table>
          </div>
        ) : (
          <div style={empty.wrap}>
            <div style={empty.icon}>🧾</div>
            <div style={empty.title}>No Expenses Yet</div>
            <div style={empty.text}>Click "+ Add Expense" to get started.</div>
          </div>
        )}

        {this.state.deleteExpense &&
          <Dialog actions={deleteAction} modal={false} open={true} autoDetectWindowHeight={true} autoScrollBodyContent={true} scroll={scroll} dividers={scroll === 'paper'}>
            <div style={{ fontFamily: "'DM Sans', 'Segoe UI', sans-serif", padding: '8px 0' }}>
              <div style={modal.confirmTitle}>Delete Expense</div>
              <div style={modal.confirmText}>Are you sure you want to delete this expense? This action cannot be undone.</div>
              <div style={modal.confirmFooter}>
                <button style={btn.cancel} onClick={() => { this.handleDeleteExpense() }}>Cancel</button>
                <button style={btn.danger} onClick={() => { this.postDeleteExpense() }}>Delete</button>
              </div>
            </div>
          </Dialog>
        }

      </div>
    );
  }
}

export default ViewCompetitionExpense;


// WEBPACK FOOTER //
// ./src/app/views/partner/crud/viewCompetitionExpense/index.js